import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, Phone } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { Logo } from "@/components/Logo";

const Col = ({ title, children }) => (
  <div>
    <p className="eyebrow text-champagne mb-5">{title}</p>
    <ul className="space-y-3 text-[15px] text-pearl/80">{children}</ul>
  </div>
);
const L = ({ to, children, id }) => (
  <li><Link to={to} data-testid={`footer-link-${id}`} className="hover:text-pearl transition-colors">{children}</Link></li>
);

export const Footer = () => {
  const { site, products } = useStore();
  const s = site.social;
  const socials = [
    { k: "instagram", url: s.instagram, Icon: Instagram },
    { k: "facebook", url: s.facebook, Icon: Facebook },
    { k: "youtube", url: s.youtube, Icon: Youtube },
  ].filter((x) => x.url);
  return (
    <footer className="bg-plum text-pearl" data-testid="site-footer">
      <div className="container-rh pt-16 lg:pt-24 pb-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5 space-y-6">
            <Logo light testId="footer-logo" />
            <p className="text-[15px] leading-relaxed text-pearl/75 max-w-sm">{site.footer.description}</p>
            <div className="flex gap-2">
              {socials.map(({ k, url, Icon }) => (
                <a key={k} href={url} target="_blank" rel="noreferrer" aria-label={k} data-testid={`footer-social-${k}`} className="grid place-items-center w-11 h-11 rounded-[14px] border border-pearl/20 hover:bg-pearl hover:text-plum transition-colors">
                  <Icon className="w-[18px] h-[18px]" />
                </a>
              ))}
            </div>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-10">
            <Col title="Shop">
              {products.slice(0, 3).map((p) => <L key={p.id} to={`/product/${p.slug}`} id={p.slug}>{p.type}</L>)}
              <L to="/shop" id="shop">All pieces</L>
            </Col>
            <Col title="Help">
              <L to="/policy/shipping" id="shipping">Shipping</L>
              <L to="/policy/returns" id="returns">Returns</L>
              <L to="/policy/care" id="care">Jewellery care</L>
              <L to="/contact" id="contact">Contact</L>
            </Col>
            <Col title="Contact">
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-champagne" /><a href={`mailto:${site.contact.email}`} className="hover:text-pearl break-all">{site.contact.email}</a></li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-champagne" /><a href={`tel:${site.contact.phone.replace(/\s/g, "")}`} className="hover:text-pearl">{site.contact.phone}</a></li>
            </Col>
          </div>
        </div>
        <div className="mt-16 pt-6 border-t border-pearl/15 flex flex-col sm:flex-row gap-3 justify-between text-[13px] text-pearl/60">
          <p>© {new Date().getFullYear()} RATNAHARA. Jewels that tell your story.</p>
          <div className="flex gap-6">
            <Link to="/policy/privacy" data-testid="footer-link-privacy" className="hover:text-pearl">Privacy</Link>
            <Link to="/policy/terms" data-testid="footer-link-terms" className="hover:text-pearl">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
